import script from "./spaInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./spaInfoList.vue?vue&type=script&setup=true&lang=js"

import "./spaInfoList.vue?vue&type=style&index=0&id=682ca9ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-682ca9ad"]])

export default __exports__